module.exports = __webpack_public_path__ + "static/media/Edberghof04.33ccb2c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Edberghof04.jpg
// module id = 366
// module chunks = 0